import { GENERATE_OTP_TAB } from "../../framework/tab/tabUtilsConstants";

export const initial_state_generate_otp = {
  type: GENERATE_OTP_TAB,
  label: "Generate OTP",
  allowMultipleTabs: false,
};
